<rk-dropdown
  [options]="options"
  [selectedOption]="selectedOption"
  (selectionChange)="onLanguageChange($event)"
></rk-dropdown>
